export const PREORDER_TYPE = 'PREORDER_TYPE';
export const ECOMMERCE_TYPE = 'ECOMMERCE_TYPE';
export const BRANCH_TYPE = 'BRANCH_TYPE';
export const SUMMARY_TYPE = 'SUMMARY_TYPE';

export const SEARCH = 'SEARCH'

